import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitActivationFilter } from '@apps-common/stores'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const QUERY_SEARCH_UNIT_ACTIVATIONS = (searchTerm?: string, status?: string, skip?: number, take?: number) =>
  ['getActivations', searchTerm, status, skip, take].filter(Boolean)

export const searchActivations = async (
  searchTerm: string,
  status: string,
  skip: number,
  take: number
): Promise<IActivationServiceRequestModel[]> =>
  axios
    .get(`/UnitActivation/SearchUnitActivationRequests?searchTerm=${searchTerm}&status=${status}&skip=${skip}&take=${take}`)
    .then((res) => res.data?.data)

type QueryFnType = typeof searchActivations

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IUnitActivationFilter
}

export const useSearchUnitActivations = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, gcTime: 0 },
    queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS(model.searchVal, model.statusVal, model.skip, model.take),
    queryFn: () => searchActivations(model.searchVal, model.statusVal, model.skip, model.take)
  })
